import React from 'react';
import styled from 'styled-components';

const LogoContainer = styled.svg`
  path {
    transition: fill 500ms ease-in-out;
  }
`;

interface MightyProLogoProps {
  width?: number;
  color?: string;
}

const MightyProLogo = ({ width = 153, color = 'white' }: MightyProLogoProps): JSX.Element => {
  return (
    <LogoContainer
      className='mighty-pro-logo'
      width={width}
      viewBox='0 0 153 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 22.9375H5V14.8125C5 11.8125 6.0625 10.9375 7.6875 10.9375C9.25 10.9375 10 11.8125 10 14V22.875H15.0625V14.75C15.0625 11.75 16.125 10.875 17.6875 10.875C19.25 10.875 20.0625 11.8125 20.0625 14V22.875H25.125V13.1875C25.125 9.875 24.0625 6.75 19.5625 6.75C17.25 6.75 15.375 7.9375 14.5 9.6875C13.8125 8 12.375 6.75 9.5625 6.75C7.375 6.75 5.75 7.875 5.0625 9.4375V7.125H0.0625V22.9375H0Z'
        fill={color}
      />
      <path
        d='M29.6253 6.125C31.4378 6.125 32.7503 4.75 32.7503 3.0625C32.7503 1.375 31.4378 0 29.6253 0C27.8128 0 26.5628 1.375 26.5628 3.0625C26.5003 4.75 27.8128 6.125 29.6253 6.125ZM27.1253 22.9375H32.0628V7.8125H27.1253V22.9375Z'
        fill={color}
      />
      <path
        d='M46.0653 7.1875V9.4375C45.2528 7.8125 43.3778 6.75 41.1903 6.75C36.6278 6.75 33.6278 10.25 33.6278 14.875C33.6278 19.5 36.4403 22.9375 41.1278 22.9375C43.1903 22.9375 45.2528 21.9375 46.0653 20.375V22.5C46.0653 25.3125 44.6903 26.3125 42.3153 26.3125C40.3153 26.3125 39.1903 25.5625 39.0028 24.3125H33.8778C33.9403 26 35.0653 27.6875 36.6903 28.6875C38.2528 29.625 40.1278 29.9375 42.3778 29.9375C44.6278 29.9375 46.5653 29.5625 48.0028 28.5C49.9403 27.1875 51.0028 24.875 51.0653 21.875V7.1875H46.0653ZM42.5028 19.125C40.2528 19.125 38.7528 17.375 38.7528 15C38.7528 12.625 40.2528 10.875 42.5028 10.875C44.8778 10.875 46.3153 12.6875 46.3153 15C46.2528 17.25 44.8778 19.125 42.5028 19.125Z'
        fill={color}
      />
      <path
        d='M63.1855 6.75049C60.8105 6.75049 58.998 7.68799 58.0605 9.43799V0.0629883H53.0605V22.938H58.0605V14.7505C58.0605 12.313 59.123 11.0005 61.123 11.0005C63.123 11.0005 63.873 12.188 63.873 14.8755V23.0005H68.9355V13.188C68.9355 8.93799 66.998 6.75049 63.1855 6.75049Z'
        fill={color}
      />
      <path
        d='M78.1234 19.0625C76.8734 19.0625 75.9359 18.6875 75.9359 16.375V11.125H79.8734V7.1875H75.9359V2.5H70.9359V17.4375C70.9359 22.6875 74.1859 23.25 76.4984 23.25C78.3109 23.25 80.2484 22.75 81.3734 22.375C81.3734 22.375 80.8109 21.25 80.5609 20.6875C80.3109 20.0625 80.0609 19 80.0609 19C79.6234 19 78.6859 19.0625 78.1234 19.0625Z'
        fill={color}
      />
      <path
        d='M92.5011 7.18799V15.0005C92.5011 17.438 91.5011 19.0005 89.4386 19.0005C87.3761 19.0005 86.6886 17.6255 86.6886 15.6255V7.18799H81.6886V16.3755C81.6886 20.313 83.5011 23.0005 87.5011 23.0005C89.8761 23.0005 91.6261 22.063 92.5011 20.3755V22.813C92.5011 25.2505 91.3136 26.3755 89.4386 26.3755C87.5636 26.3755 86.8136 25.563 86.6886 24.2505H81.6261C81.6886 25.938 82.4386 27.438 83.5636 28.3755C84.8761 29.438 86.6886 30.0005 89.3761 30.0005C92.0011 30.0005 93.7511 29.3755 95.1886 28.188C96.5011 27.0005 97.4386 25.063 97.4386 22.5005V7.18799H92.5011Z'
        fill={color}
      />
      <path
        d='M121.972 15.0135C121.972 19.951 118.91 23.326 114.597 23.326C112.285 23.326 110.347 22.1385 109.535 20.701V29.451H104.535V7.13846H109.535V9.38846C110.41 7.88846 112.347 6.70096 114.722 6.70096C119.035 6.70096 121.972 10.076 121.972 15.0135ZM116.847 15.0135C116.847 12.576 115.285 10.8885 113.097 10.8885C110.847 10.8885 109.285 12.576 109.285 15.0135C109.285 17.5135 110.847 19.201 113.097 19.201C115.285 19.201 116.847 17.5135 116.847 15.0135Z'
        fill={color}
      />
      <path
        d='M123.159 7.13811H128.159V10.4506C128.721 8.07561 130.596 6.88811 132.534 6.88811C133.096 6.88811 133.471 6.95061 133.846 7.01311V11.6381C133.284 11.5756 132.971 11.5131 132.346 11.5131C129.659 11.5131 128.159 13.2631 128.159 16.7631V22.8256H123.159V7.13811Z'
        fill={color}
      />
      <path
        d='M135.158 15.0135C135.158 10.201 138.47 6.70096 143.908 6.70096C149.283 6.70096 152.658 10.201 152.658 15.0135C152.658 19.826 149.345 23.326 143.908 23.326C138.47 23.3885 135.158 19.826 135.158 15.0135ZM147.72 15.0135C147.72 12.6385 146.283 10.951 143.97 10.951C141.595 10.951 140.22 12.6385 140.22 15.0135C140.22 17.3885 141.595 19.076 143.97 19.076C146.283 19.1385 147.72 17.451 147.72 15.0135Z'
        fill={color}
      />
    </LogoContainer>
  );
};

export default MightyProLogo;
